function namelist() {
  const name = [
    'フォニイ',
    'Overdose ',
    '可愛くてごめん',
    '残機',
    '何にでも牛乳を注ぐ女',
    '回る空うさぎ',
    'ガーネット',
    'テレキャスタービーボーイ',
    '斜陽',
    'きゅうくらりん',
    'Booo!',
    '三日月ステップ',
    '私は、私達は',
    'サインはB',
    'ラビットホール',
    '月のワルツ',
    '勇者',
    '猛独が襲う',
    '撫でんな',
    'HappyHalloween',
    'カワキヲアメク',
    'クラクラ',
    'キュートなカノジョ',
  ]
  return name
}
export default namelist
